import { render, staticRenderFns } from "./RatingDialog.vue?vue&type=template&id=33fc3c47&scoped=true"
import script from "./RatingDialog.vue?vue&type=script&lang=ts"
export * from "./RatingDialog.vue?vue&type=script&lang=ts"
import style0 from "./RatingDialog.vue?vue&type=style&index=0&id=33fc3c47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc3c47",
  null
  
)

export default component.exports